import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Table, Alert } from 'reactstrap';

import * as vars from '../../constants/constants';

import { console_log } from "../../utils/helper";

class Domain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domainName: '',
            domainUrl: '',
            isValid: false,
            errorMessage: '',
            countryModal: false,
            domainId: 0,
            countries: []
        };
    }

    render() {
        return (
            <div className="domain animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Domain</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="domainName">Domain Name</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="domainName" name="domainName" placeholder="Domain Name" value={this.state.domainName} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="domainUrl">URL</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="domainUrl" name="domainUrl" placeholder="URL (Ex. http://game-lords.com)" value={this.state.domainUrl} />
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary"><i className="fa fa-check"></i> Add</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Table hover responsive size="lg" className="domain-custom-table">
                                    <thead>
                                        <tr>
                                            <th>Domain</th>
                                            <th>URL</th>
                                            <th>Country</th>
                                            <th>Enabled</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>Domain Name</strong></td>
                                            <td>www.google.com</td>
                                            <td>
                                                <span className="gray-highlight"> IN </span>
                                            </td>
                                            <td>
                                                <Label className="switch switch-text switch-pill switch-success">
                                                    <Input type="checkbox" className="switch-input" checked={false} />
                                                    <span className="switch-label" data-on="On" data-off="Off"></span>
                                                    <span className="switch-handle"></span>
                                                </Label>
                                            </td>
                                            <td>
                                                <Button size="sm" color="success">
                                                    <i className="fa fa-edit"></i>
                                                </Button>
                                                <Button size="sm" color="danger">
                                                    <i className="fa fa-trash"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5}>
                                                No Domains Added Yet.
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/*<CountryModal show={this.state.countryModal} countries={this.state.countries} domainId={this.state.domainId} modalToggle={this._getCountryModalToggle} mapCountryDomain={this.mapCountryDomain}/>*/}
            </div>
        )
    }
}

export default Domain;


// WEBPACK FOOTER //
// ./src/components/Domain/Domain.js